// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"3986bb16","289":"9a21fb14"}[chunkId] + ".chunk.css";
};